import styled from '@emotion/styled';
import { memo, useCallback } from 'react';
import { useSnapshot } from 'valtio';
import { signalrStore2 } from '~/modules/SDK/Signalr/signalrStore2';
import { useSymbolDictionaryStore } from '~/modules/SDK/Symbol/useSymbolDictionaryStore';
import { useSymbolWatchList } from '~/modules/WatchList/useSymbolWatchList';
import { processQuoteToReadable } from '~/utils/processQuoteToReadable';
import { Kbar } from '../Kbar';
import { fill_horizontal_all_center, fill_vertical_all_center, } from '~/modules/AppLayout/FlexGridCss';
import { useSortSignalrDataStore } from '~/modules/symbolQuote/simple/useSortStore';
import { SortArrow } from '../content/SortArrow';
import { turnoverDataStore } from '../content/TurnoverContent';
import { store } from '~/pages/heineken_template/_private/store';
import { RiAddLine } from 'react-icons/ri';
import { VscClose } from 'react-icons/vsc';
const KbarTurnoverBody = memo(function KbarTurnoverBody(props) {
    const { state: watchListState1, acts: watchListActs1 } = useSymbolWatchList(props.groupName);
    const quote = props.quote;
    const turnoverRate = props.data;
    const dictionary = useSymbolDictionaryStore(s => s.dictionary);
    const value = useSnapshot(signalrStore2.values.quote)[quote.symbol];
    const quoteChanges = processQuoteToReadable(value);
    const quoteChangesPercent = quoteChanges.closeChangePercent;
    const changeArrow = quoteChangesPercent > 0 ? '+' : '';
    const close = value?.close ?? 0;
    const volume = value?.volume ?? 0;
    const amount = (close * 1000 * volume) / 1e8;
    const hadSymbol = watchListState1.symbolListArray.includes(quote.symbol);
    const turnove = turnoverRate.turnover_rate * 100;
    const avgTurnove = turnoverRate.avg_turnover_rate * 100;
    const charting = useSnapshot(store).charting;
    const selected = charting.symbol === quote.symbol;
    return (<styleds.body.container onClick={() => store.charting.changeSymbol(quote.symbol)} selected={selected}>
      <styleds.body.addButton onClick={event => {
            event.stopPropagation();
            !hadSymbol
                ? watchListActs1.addSymbol(quote.symbol, 30)
                : watchListActs1.removeSymbol(quote.symbol);
        }}>
        {!hadSymbol && <RiAddLine color='#cacaca'/>}
        {hadSymbol && <VscClose color='#e95050'/>}
      </styleds.body.addButton>
      <styleds.body.content>
        <Kbar quote={value}/>
      </styleds.body.content>
      <styleds.body.symbolNameContent>
        <span>{dictionary[quote.symbol]}</span>
        <span>{quote.symbol}</span>
      </styleds.body.symbolNameContent>
      <styleds.body.quote quote={quoteChangesPercent}>
        {changeArrow}
        {quoteChangesPercent.toFixed(2)}
      </styleds.body.quote>
      <styleds.body.content>{turnove.toFixed(1)}%</styleds.body.content>
      <styleds.body.content>{avgTurnove.toFixed(1)}%</styleds.body.content>
      <styleds.body.content>{amount.toFixed(1)}億</styleds.body.content>
    </styleds.body.container>);
});
const KbarTurnoverHeader = memo(function KbarTurnoverHeader() {
    const sortState = useSnapshot(useSortSignalrDataStore);
    const sortTurnoverState = useSnapshot(turnoverDataStore);
    const toggleOrderKey = sortState.orderKey === 'desc' ? 'asc' : 'desc';
    const handleColumnSelected = useCallback((sortKey) => {
        useSortSignalrDataStore.sortKey = sortKey;
        useSortSignalrDataStore.orderKey = toggleOrderKey;
    }, [toggleOrderKey]);
    const toggleTrustOrderKey = sortTurnoverState.orderKey === 'desc' ? 'asc' : 'desc';
    const handleTurstSelected = useCallback((sortKey) => {
        ;
        (turnoverDataStore.sortKey = sortKey), (turnoverDataStore.orderKey = toggleTrustOrderKey);
    }, [toggleTrustOrderKey]);
    return (<styleds.header.container>
      <styleds.header.item></styleds.header.item>
      <styleds.header.item onClick={() => {
            handleColumnSelected('changePrecent');
            handleTurstSelected('none');
        }}>
        K棒
      </styleds.header.item>
      <styleds.header.item onClick={() => {
            handleColumnSelected('symbol');
            handleTurstSelected('none');
        }}>
        代號
        <SortArrow sortKey='symbol' sotre={useSortSignalrDataStore}/>
      </styleds.header.item>
      <styleds.header.item onClick={() => {
            handleColumnSelected('changePrecent');
            handleTurstSelected('none');
        }}>
        幅度%
        <SortArrow sortKey='changePrecent' sotre={useSortSignalrDataStore}/>
      </styleds.header.item>
      <styleds.header.item onClick={() => {
            handleTurstSelected('turnover_rate');
            handleColumnSelected('none');
        }}>
        週轉率
        <SortArrow sortKey='turnover_rate' sotre={turnoverDataStore}/>
      </styleds.header.item>
      <styleds.header.item onClick={() => {
            handleTurstSelected('avg_turnover_rate');
            handleColumnSelected('none');
        }}>
        均週轉率
        <SortArrow sortKey='avg_turnover_rate' sotre={turnoverDataStore}/>
      </styleds.header.item>
      <styleds.header.item onClick={() => {
            handleColumnSelected('amount');
            handleTurstSelected('none');
        }}>
        成交值
        <SortArrow sortKey='amount' sotre={useSortSignalrDataStore}/>
      </styleds.header.item>
    </styleds.header.container>);
});
export default { body: KbarTurnoverBody, header: KbarTurnoverHeader };
const styleds = {
    header: {
        container: styled.div `
      display: grid;
      grid-template-columns: 4% 10% 18% 16% 16% 20% 16%;
      height: 36px;
      width: 100%;
      border-radius: 4px;
      cursor: pointer;
      background-color: #1a1e27;
      user-select: none;
    `,
        item: styled.div `
      ${fill_horizontal_all_center};
      font-size: 12px;
    `,
    },
    body: {
        container: styled.div `
      display: grid;
      grid-template-columns: 4% 10% 18% 14% 18% 18% 18%;
      height: 36px;
      width: 100%;
      border-radius: 4px;
      padding: 2px 4px;
      font-size: 13px;
      cursor: pointer;
      border: 1px solid ${props => (props.selected ? '#c7c7c7' : 'transparent')};
      background-color: #141821;
      &:hover {
        background-color: #1b1e26;
        transition: 0.3s;
      }
      flex-shrink: 0;
    `,
        addButton: styled.div `
      ${fill_horizontal_all_center};
      justify-content: end;
      height: 50%;
      margin-top: 9px;
      border-radius: 4px;
      &:hover {
        transform: scale(1.2);
      }
      &:active {
        transform: scale(1.4);
      }
    `,
        content: styled.div `
      ${fill_horizontal_all_center};
      justify-content: end;
    `,
        quote: styled.div `
      ${fill_horizontal_all_center};
      width: 42px;
      border-radius: 6px;
      color: ${props => (props.quote > 0 ? '#d51f1f' : props.quote < 0 ? '#59c03d' : '#cccc22')};
      font-size: 13px;
      font-weight: 500;
      justify-content: end;
    `,
        symbolNameContent: styled.div `
      ${fill_vertical_all_center};
      align-items: start;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 12px;
      &:hover {
        overflow: visible;
      }
      & > * {
        line-height: 12px;
      }
    `,
    },
};
